import { MessageCircle } from "lucide-react";
import { CONTACT } from "../data/content";
import { useLanguage } from "../i18n/LanguageContext";

export const FloatingWhatsApp = () => {
  const { t } = useLanguage();
  return (
    <a
      data-testid="floating-whatsapp-btn"
      href={CONTACT.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("wa.aria")}
      className="group fixed bottom-5 right-5 z-[60] flex items-center gap-0 rounded-full bg-[#1EBE5D] p-4 shadow-[0_8px_30px_rgba(30,190,93,0.35)] transition-all duration-300 hover:gap-3 hover:px-6 rtl:right-auto rtl:left-5"
    >
      <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#1EBE5D]/40 [animation-duration:2.6s]" />
      <MessageCircle className="h-6 w-6 text-white" fill="white" strokeWidth={0} />
      <span className="max-w-0 overflow-hidden whitespace-nowrap font-display text-sm font-semibold text-white transition-all duration-300 group-hover:max-w-[160px]">
        {t("wa.label")}
      </span>
    </a>
  );
};
